import React from 'react';

const statusColors = {
    pending: 'bg-gray-100 text-gray-800',
    contacted: 'bg-blue-100 text-blue-800',
    interested: 'bg-purple-100 text-purple-800',
    converted: 'bg-green-100 text-green-800',
    not_interested: 'bg-red-100 text-red-800',
    failed: 'bg-yellow-100 text-yellow-800',
};

const StatusBadge = ({ status }) => {
    const getStatusLabel = (status) => {
        return status
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${statusColors[status] || 'bg-gray-100 text-gray-800'}`}>
            {getStatusLabel(status)}
        </span>
    );
};

export default StatusBadge;